module.exports = __webpack_public_path__ + "static/party-7ab708168b8b075a3e75d35cdaa291a1.png";